<template>
    <div class="benefit-container container">
        <div class="row">
            <h2 class="col-sm-12 heading heading--1 benefit-container__heading">{{ title }}</h2>
        </div>
        <div class="row justify-content-center">
            <template v-for="benefit in benefits">
                <div v-if="benefit.title && benefit.key !== 'Z'" :class="benefitClass" :key="benefit.id">
                    <div class="benefit-container__benefits">
                        <benefit-preview :benefit="benefit" :big-logo="bigLogo"></benefit-preview>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
    import BenefitPreview from "./BenefitPreview";
    export default {
        components: {BenefitPreview},
        props: ["benefits", "title"],
        computed: {
          benefitClass() {
            if (this.benefits.length === 1) {
              return "col-md-8 col-xl-6 benefit-container__col";
            }
            return "col-md-6 col-lg-4 col-xl-3 benefit-container__col";
          },
          bigLogo() {
            if (this.benefits.length === 1) {
              return true;
            }
            return false;
          },
        }
    }
</script>

<style lang="scss">
    .benefit-image {
        max-height: 20px;
        }
    .benefit-container {
        margin-bottom: 100px;

        @media (max-width: 1203px) {
            margin-bottom: 40px;
        }


        &__col {
            margin-bottom: 20px;
        }

        &__heading {
            &.heading {
                margin-bottom: 40px;
            }
        }

        &__benefits {
            margin-bottom: 5px;
            padding: 20px;
            height: 100%;
            background-color: #fafafa;
            position: relative;
        }
    }
</style>


